import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class DemandCreateEdit {
  constructor($scope, $filter, UserService, GeoService, ProductService, UserProductService, DemandService) {
    $scope.tabs = ['1. Title', '2. Synopsis', '3. Basic Infos', '4. Product Specs', '5. More Infos'];

    $scope.sections = [
      {
        title: 'Main Infos',
        tabs: ['Title', 'Synopsis', 'Basic Infos', 'Product Specs', 'More Infos'],
        selected_tab: 0
      },
      {
        title: 'Advanced',
        tabs: ['Tags & Keywords', 'Country Restrictions'],
        selected_tab: 0
      }
    ];

    $scope.set_selected_tab = function(index) {
      if (window.on_create_page)
        $scope.selected_tab = index;
      else
        $scope.sections[$scope.selected_section].selected_tab = index;
    };

    $scope.get_selected_tab = function() {
      if (window.on_create_page)
        return $scope.selected_tab;
      else
        return $scope.sections[$scope.selected_section].selected_tab;
    };

    $scope.set_selected_section = function(index) {
      $scope.selected_section = index;
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '300px'
    };

    $scope.set_user_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.demand.user_id = ui.item.id;
          $scope.demand.user_contact_id = null;
          $scope.demand.buyer_company = ui.item.value;
          $scope.$apply();
          $scope.update_buyer_data(ui.item.id, true);
        }
      });
    };

    $scope.update_buyer_data = function(user_id, set_delivery_terms) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.user_contacts = data.contacts;
      });
      UserService.get_demand_data(user_id).then(function(data) {
        $scope.buyer_origin = data.origin;
        if (set_delivery_terms) {
          $scope.demand.currency_id = data.currency_id;
          $scope.demand.cfr_country_id = data.cfr_country_id;
          $scope.demand.cfr_city_id = data.cfr_city_id;
          $scope.demand.dap_country_id = data.dap_country_id;
          $scope.demand.dap_city_id = data.dap_city_id;
          $scope.demand.fob_country_id = data.fob_country_id;
          $scope.demand.fob_city_id = data.fob_city_id;
        }
      });
    };

    $scope.$watch('demand.cfr_country_id', function() {
      if ($scope.demand.cfr_country_id) {
        GeoService.get_cities($scope.demand.cfr_country_id).then(function(data) {
          $scope.cfr_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.demand.cfr_city_id}))
            $scope.demand.cfr_city_id = null;
        });
      }
    });

    $scope.$watch('demand.dap_country_id', function() {
      if ($scope.demand.dap_country_id) {
        GeoService.get_cities($scope.demand.dap_country_id).then(function(data) {
          $scope.dap_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.demand.dap_city_id}))
            $scope.demand.dap_city_id = null;
        });
      }
    });

    $scope.$watch('demand.fob_country_id', function() {
      if ($scope.demand.fob_country_id) {
        GeoService.get_cities($scope.demand.fob_country_id).then(function(data) {
          $scope.fob_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.demand.fob_city_id}))
            $scope.demand.fob_city_id = null;
        });
      }
    });

    $scope.$watch('demand.product_category_id', function() {
      ProductService.get_groups($scope.demand.product_category_id).then(function(data) {
        $scope.product_groups = data.groups;
      });
      ProductService.get_product_properties_by_category($scope.demand.product_category_id).then(function(data) {
        $scope.product_grades = data.product_grades;
        $scope.product_finishes = data.product_finishes;
        $scope.product_types = data.product_types;
        $scope.product_printing_methods = data.product_printing_methods;
        $scope.product_colors = window.product_colors;
      });
    });

    $scope.$watch('demand.product_group_id', function() {
      ProductService.get_products($scope.demand.product_group_id).then(function(data) {
        $scope.products = data.products;
      });
      if ($scope.demand.product_group_id) {
        ProductService.get_product_properties_by_group($scope.demand.product_group_id).then(function(data) {
          $scope.product_grades = data.product_grades;
          $scope.product_finishes = data.product_finishes;
          $scope.product_types = data.product_types;
          $scope.product_printing_methods = data.product_printing_methods;
          $scope.product_colors = data.product_colors;
        });
      }
    });

    $scope.$watch('demand.product_id', function() {
      $scope.product_end_uses = [];
      if ($scope.demand.product_id) {
        ProductService.get_product_end_uses($scope.demand.product_id).then(function(data) {
          angular.forEach(data.end_uses, function(object) {
            var checked = $scope.demand.end_uses.epaper.indexOf(object.id) > -1;
            var end_use = {
              id: object.id,
              title: object.title,
              checked: checked
            };
            $scope.product_end_uses.push(end_use);
          });
        });
        var item = $filter('filter')($scope.products, {
          product: {
            id: $scope.demand.product_id
          }
        });
        if (item) {
          var product = item[0].product;
          $scope.demand.product_grade_id = product.product_grade_id;
          $scope.demand.product_finish_id = product.product_finish_id;
          $scope.demand.product_type_id = product.product_type_id;
          $scope.demand.product_printing_methods.printing_methods = product.printing_methods;
          $scope.demand.product_colors.colors = product.colors;
        }
      }
    });

    $scope.load_user_notes = function() {
      if ($scope.demand.user_id) {
        UserService.get_notes($scope.demand.user_id).then(function(data) {
          $scope.demand.notes = data.notes;
        });
      } else {
        alert('Please select a buyer!');
      }
    };

    $scope.add_accurate = function(property) {
      property.push('0');
    };

    $scope.add_range = function(property) {
      property.push({
        from: '0',
        to: '0'
      });
    };

    $scope.add_substance_accurate = function(property) {
      property.push({
        value: '0',
        reel_combinations: [],
        sheet_combinations: []
      });
    };

    $scope.add_substance_range = function(property) {
      property.push({
        from: '0',
        to: '0',
        reel_combinations: [],
        sheet_combinations: []
      });
    };

    $scope.has_reel_combinations = function(substance) {
      return substance.reel_combinations.length > 0;
    };

    $scope.has_sheet_combinations = function(substance) {
      return substance.sheet_combinations.length > 0;
    };

    $scope.get_combination_str = function(value) {
      return UserProductService.get_combination_str(value);
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.set_reel_combination_edit = function(substance) {
      $scope.reel_combination_edit = {
        substance: substance
      };
      $scope.reel_combination_edit.reel_rw_accurate = $scope.get_rw_combined_values($scope.demand.product_specs.reel_rw_accurate);
      $scope.reel_combination_edit.reel_rw_range = $scope.get_rw_combined_values($scope.demand.product_specs.reel_rw_range);
    };

    $scope.set_sheet_combination_edit = function(substance) {
      $scope.sheet_combination_edit = {
        substance: substance
      };
      $scope.sheet_combination_edit.sheet_size_range = $scope.get_size_combined_values($scope.demand.product_specs.sheet_size_range);
    };

    $scope.get_rw_combined_values = function(values) {
      var object = [];
      angular.forEach(values, function(value) {
        var checked = $scope.reel_combination_exists(value);
        if (typeof(value) == 'string')
          object.push({
            value: value,
            checked: checked
          });
        else
          object.push({
            from: value.from,
            to: value.to,
            checked: checked
          });
      });
      return object;
    };

    $scope.get_size_combined_values = function(values) {
      var object = [];
      angular.forEach(values, function(value) {
        var checked = $scope.sheet_combination_exists(value);
        object.push({
          from: value.from,
          to: value.to,
          checked: checked
        });
      });
      return object;
    };

    $scope.get_reel_combination_edit_substance = function() {
      if ($scope.reel_combination_edit) {
        if ($scope.reel_combination_edit.substance.value)
          return $scope.reel_combination_edit.substance.value;
        else
          return $scope.reel_combination_edit.substance.from + ' - ' + $scope.reel_combination_edit.substance.to;
      }
    };

    $scope.reel_combination_exists = function(rw) {
      var lookup = null;
      if (typeof(rw) == 'string')
        lookup = rw;
      else
        lookup = {
          from: rw.from,
          to: rw.to
        };
      var index = $scope.reel_combination_edit.substance.reel_combinations.indexOf($filter('filter')($scope.reel_combination_edit.substance.reel_combinations, lookup)[0]);
      return index > -1;
    };

    $scope.sheet_combination_exists = function(size) {
      var lookup = {
        from: size.from,
        to: size.to
      };
      var index = $scope.sheet_combination_edit.substance.sheet_combinations.indexOf($filter('filter')($scope.sheet_combination_edit.substance.sheet_combinations, lookup)[0]);
      return index > -1;
    };

    $scope.update_reel_combinations = function() {
      $scope.reel_combination_edit.substance.reel_combinations = [];
      angular.forEach($scope.reel_combination_edit.reel_rw_accurate, function(value) {
        if (value.checked)
          $scope.reel_combination_edit.substance.reel_combinations.push(value.value);
      });
      angular.forEach($scope.reel_combination_edit.reel_rw_range, function(value) {
        if (value.checked)
          $scope.reel_combination_edit.substance.reel_combinations.push({
            from: value.from,
            to: value.to
          });
      });
      $scope.reel_combination_edit = null;
    };

    $scope.update_sheet_combinations = function() {
      $scope.sheet_combination_edit.substance.sheet_combinations = [];
      angular.forEach($scope.sheet_combination_edit.sheet_size_range, function(value) {
        if (value.checked)
          $scope.sheet_combination_edit.substance.sheet_combinations.push({
            from: value.from,
            to: value.to
          });
      });
      $scope.sheet_combination_edit = null;
    };

    $scope.get_epaper_end_use = function(end_use_id) {
      return $filter('filter')(window.epaper_end_uses, {
        id: end_use_id
      })[0];
    };

    $scope.add_custom_end_use = function() {
      $scope.demand.end_uses.custom.push($scope.custom_end_use);
      $scope.custom_end_use = null;
    };

    $scope.delete_custom_end_use = function(end_use) {
      var index = $scope.demand.end_uses.custom.indexOf(end_use);
      if (index > -1)
        $scope.demand.end_uses.custom.splice(index, 1);
    };

    $scope.delete_epaper_end_use = function(end_use) {
      var index = $scope.demand.end_uses.epaper.indexOf(end_use);
      if (index > -1)
        $scope.demand.end_uses.epaper.splice(index, 1);
      var checked_index = $scope.product_end_uses.indexOf($filter('filter')($scope.product_end_uses, {
        id: end_use
      })[0]);
      if (checked_index > -1)
        $scope.product_end_uses[checked_index].checked = false;
    };

    $scope.$watch('product_end_uses | json', function() {
      angular.forEach($scope.product_end_uses, function(object) {
        var index = $scope.demand.end_uses.epaper.indexOf(object.id);
        if (object.checked && index < 0)
          $scope.demand.end_uses.epaper.push(object.id);
        else if (!object.checked && index > -1)
          $scope.demand.end_uses.epaper.splice(index, 1);
      });
    });

    $scope.create_demand = function() {
      DemandService.save($scope.demand).then(function(data) {
        if (data.success) {
          $scope.created_demand_id = data.demand_id;
          $scope.create_mode = false;
        }
      });
    };

    $scope.update_demand = function() {
      $scope.updating_demand = true;
      DemandService.save($scope.demand).then(function(data) {
        if (data.success)
          $scope.updating_demand = false;
      });
    };

    $scope.create_new_demand = function() {
      $scope.demand = angular.copy(window.demand);
      $scope.selected_tab = 0;
      $scope.create_mode = true;
    };

    $scope.init_create = function() {
      $scope.selected_tab = 0;
      $scope.create_mode = true;
      window.demand.product_printing_methods = {
        printing_methods: []
      };
      window.demand.product_colors = {
        colors: []
      };
      window.demand.product_specs = {
        substance_accurate: [{
          value: '0',
          reel_combinations: [],
          sheet_combinations: []
        }],
        substance_range: [{
          from: '0',
          to: '0',
          reel_combinations: [],
          sheet_combinations: []
        }],
        reel_rw_accurate: ['0'],
        reel_rw_range: [{
          from: '0',
          to: '0'
        }],
        reel_diameter_range: [{
          from: '0',
          to: '0'
        }],
        reel_core_range: [{
          from: '0',
          to: '0'
        }],
        sheet_size_range: [{
          from: '0',
          to: '0'
        }]
      };
      window.demand.end_uses = {
        custom: [],
        epaper: []
      };
      window.demand.pricings = {
        reel_cfr_min: '0',
        reel_cfr_max: '0',
        reel_dap_min: '0',
        reel_dap_max: '0',
        sheet_cfr_min: '0',
        sheet_cfr_max: '0',
        sheet_dap_min: '0',
        sheet_dap_max: '0'
      };
      $scope.demand = angular.copy(window.demand);
    };

    $scope.selected_section = 0;
    $scope.product_colors = window.product_colors;
    if (window.on_create_page)
      $scope.init_create();
    else
      $scope.init_edit();
    $scope.set_user_company_autocomplete($('input.user_company'));
  }
}

DemandCreateEdit.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'ProductService', 'UserProductService', 'DemandService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/demand-create-edit.ctrl.js